<script>
import VueTelInput from "vue-tel-input";
import Person from "../../models/UserSignUp";
import {APP_CONFIG} from "../../config";
import Password from "vue-password-strength-meter";
import {axios} from "../../bootstrap";

export default {
    name: "DeveloperSignUp",
    data() {
        return {
            loading: false,
            errors: {},
            person: Person,
            phoneNumber: ""
        };
    },
    components: {
        "vue-tel-input": VueTelInput,
        Password
    },
    methods: {
        validatePhone({number, isValid}) {
            this.person.phoneNumber = isValid ? number : "";
        },
        socialLogin(provider) {
            axios.get(`${APP_CONFIG.URL}auth/${provider}`).then(res => {
                window.location.assign(res.data.redirectUrl);
            }).catch(err => {
                this.$notify({
                    message: "We could not initiate your login request",
                    title: "Login Failed",
                    position: "bottom-right"
                });
            });
        },
        async registerUser() {
            this.loading = true;
            // (optional) Wait until recaptcha has been loaded.
            await this.$recaptchaLoaded()
            this.person.identityToken = await this.$recaptcha('signup')
            axios.post(APP_CONFIG.URL + "register", this.person).then(() => {
                this.$notify({
                    title: "Registration Complete",
                    message: "Your account is ready please log in to your new account",
                    type: "success"
                });
                this.$router.push("/login");
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.$notify({
                        title: "Whoops !!",
                        message: "Seems like there is an issue connecting to our backend",
                        type: "error"
                    });
                }
                this.loading = false;
            });
        }
    }
};
</script>

<template>
    <div class="container">
        <div class="row">
            <div class="signup-content d-flex align-items-center">
                <div class="col-xl-6 col-lg-6 col-md-6 d-none d-lg-block">
                    <div class="col-9">
                        <div align="center">
                            <img src="/images/logo2.png" alt/>
                        </div>
                        <div class="mb-4" align="center">
                            <img src="/images/signup.png" class="img-fluid"/>
                        </div>
                        <h1 class="heading-info h-color mb-4">Engage your customers on any channel they prefer.</h1>
                        <p class="signup-p">
                            Use our unified platform to access SMS, VAS
                            Services, Voice, Payments, Chats, USSD Codes and
                            Survey for your business. In a cost-effective way.
                        </p>
                    </div>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6">
                    <div class="card block block-bordered">
                        <div class="card-body block-content">
                            <div class="card-header bg-white mb-2" align="center">
                                <h1 class="heading-info">Create a new account</h1>
                                <span class="signup-card-info">
                  Already have an account? &nbsp;
                  <router-link :to="{ name: 'login' }">Log In</router-link>
                </span>
                            </div>
                            <form class="form" @submit.prevent="registerUser" autocomplete="off">
                                <div class="form-group">
                                    <label>Full Name</label>
                                    <el-input v-model="person.name" placeholder="Enter your full name"/>
                                    <div v-if="errors.name" :class="['text-danger', 'help-block']">{{ errors.name[0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Phone Number</label>
                                    <vue-tel-input
                                            v-model="phoneNumber"
                                            @onInput="validatePhone"
                                            class="form-control"
                                            :preferredCountries="['ke', 'tz', 'ug']"
                                    ></vue-tel-input>
                                    <div
                                            v-if="errors.phoneNumber"
                                            :class="['text-danger', 'help-block']"
                                    >{{ errors.phoneNumber[0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Email address</label>
                                    <el-input
                                            v-model="person.email"
                                            type="email"
                                            placeholder="Enter Email Address..."
                                    />
                                    <div
                                            v-if="errors.email"
                                            :class="['text-danger', 'help-block']"
                                    >{{ errors.email[0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>Password</label>
                                    <el-input
                                            v-model="person.password"
                                            type="password"
                                            show-password
                                            placeholder="Password"
                                    />
                                    <password v-model="person.password" :strength-meter-only="true"/>
                                    <div
                                            v-if="errors.password"
                                            :class="['text-danger', 'help-block']"
                                    >{{ errors.password[0] }}
                                    </div>
                                </div>

                                <button type="submit" class="btn btn-primary btn-block signup-btn mb-2">
                                    <i class="el-icon-loading" v-if="loading"></i>
                                    Sign up
                                </button>
                            </form>
                            <div class="mt-2 text-center">
                                <p class="or">
                                    <span>or sign up with</span>
                                </p>
                            </div>
                            <div class="flex-column mb-3">
                                <button
                                        class="btn btn-outline btn-outline-secondary"
                                        @click="socialLogin('github')"
                                >
                                    <i class="mr-1 fab fa-github"/>
                                    Github
                                </button>
                                <button
                                        class="btn btn-outline btn-outline-primary float-right"
                                        @click="socialLogin('google')"
                                >
                                    <i class="mr-1 fab fa-google"/>
                                    Google
                                </button>
                            </div>
                        </div>
                        <div class="card-footer signup-card-bottom-info mb-3">
                            <span class="signup-card-bottom-info-text">
                              By signing up and creating an account you agree
                              to our
                            </span>
                            <br/>
                            <a href="terms.html" class="terms-link">Terms and Conditions</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../sass/custom/mixins";

.signup-content {
    min-height: 100vh;
}

.heading-info {
    letter-spacing: 0;
    color: #2c3f58;
    opacity: 1;
    font-size: 25px;
    font-weight: 700;

    p {
        margin-bottom: 0.2rem;
    }
}

.h-color {
    color: #005da2;
}

.signup-p {
    text-align: left;
    letter-spacing: 0;
    color: #2c3f58;
    opacity: 1;
    font-weight: 400;
    font-size: 14px;
}

.fz-24 {
    font-size: 18px;
    font-weight: 800 !important;
}

.fz-22 {
    font-size: 22px;
    font-weight: 800 !important;
}

.card {
    @include for-desktop-up() {
        margin-left: 10rem;
    }
}

.signup-card-info {
    font-size: 12px;
    font-weight: 600;
    color: #778699;
    margin-top: 0px;
}

.signup-card-bottom-info {
    font-size: 9px;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0;
    color: #778699;
    opacity: 1;
}

.card-footer {
    background-color: #ffffff;
}

.terms-link {
    text-decoration: none;
    font-weight: 800;
    color: #2985ef;
}

.link {
    font: 14px/22px;
    letter-spacing: 0;
    color: #2985ef;
    opacity: 1;
}

label {
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    color: #254050;
    opacity: 1;
}

.signup-btn {
    background: #2985ef 0% 0% no-repeat padding-box;
    border-color: #2985ef;
    border-radius: 6px;
    opacity: 1;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0;
    color: #ffffff;
}

.signup-btn:hover {
    background-color: #ffffff;
    color: #2985ef;
    border-color: #2985ef;
    border-radius: 6px;
    opacity: 1;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
}

.signup-input {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #dce1e7;
    border-radius: 8px;
    opacity: 1;
    font-size: 14px;
}

.signup-input:active:focus {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #2985ef;
    border-radius: 8px;
    opacity: 1;
    font-size: 14px;
}

.text-google {
    color: #eac043 !important;
    position: relative;
    top: 3px;
}

.margin-25 {
    margin-top: 25%;
    margin-bottom: 25%;
}

@media (max-width: 768px) {
    .none {
        display: none;
    }
}

@media (min-width: 768px) {
    .none {
        display: block;
    }
}

.text-google2 {
    color: #ffffff !important;
    position: relative;
}

.text-google3 {
    color: #ffffff !important;
    position: relative;
    top: 3px;
}

.dropdown ul {
    z-index: 1050 !important;
}

.el-form-item__content {
    line-height: 26px !important;
}
</style>
